import React from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import PageHeader from '../common/PageHeader';
import BulkUnos from './BulkUnos';
import ZaIzbacivanje from './ZaIzbacivanje';

/* "Učitaj bulk": više fotografija analognih listića odjednom — prepoznavanje aktivnosti (TachoBulk/engine),
   pregled strelicama, upis u UTC i evidencija listića koje treba izbaciti. */
export default function TachoBulk({ active }) {
    return (
        <>
            <PageHeader title="Bulk listići" subtitle="Više listića odjednom: motor čita traku aktivnosti, vi proveravate i upisujete." />
            <TabView className="page-tabs">
                <TabPanel header="Unos" leftIcon="pi pi-images"><BulkUnos active={active} /></TabPanel>
                <TabPanel header="Za izbacivanje" leftIcon="pi pi-trash"><ZaIzbacivanje active={active} /></TabPanel>
            </TabView>
        </>
    );
}
